import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from '../../../environments/environment';

interface DynatraceAPI {
  enable?: () => void;
  disable?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class DynatraceService {

  readonly #SCRIPT_ID = 'dt-snippet';
  readonly #SCRIPT_SRC = environment.dynatraceUrl;
  #renderer: Renderer2;
  #scriptLoaded = false;
  #optedIn = false;

  constructor(rendererFactory: RendererFactory2) {
    this.#renderer = rendererFactory.createRenderer(null, null);
  }

  #api(): DynatraceAPI | undefined {
    return (window as any).dtrum;
  }

  load(): void {
    if (!this.#SCRIPT_SRC || this.#SCRIPT_SRC.includes('__')) {
      return;
    }

    this.#optedIn = true;
    this.#applyOptState();

    if (this.#scriptLoaded || document.getElementById(this.#SCRIPT_ID)) {
      return;
    }

    const script = this.#renderer.createElement('script') as HTMLScriptElement;
    script.id = this.#SCRIPT_ID;
    script.type = 'text/javascript';
    script.src = this.#SCRIPT_SRC;
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.onload = () => {
      this.#scriptLoaded = true;
      this.#applyOptState();
    };
    script.onerror = (error) => {
      console.error('Failed to load Dynatrace script:', error);
      const node = document.getElementById(this.#SCRIPT_ID);
      if (node) this.#renderer.removeChild(document.body, node);
    };

    this.#renderer.appendChild(document.body, script);
  }

  unload(): void {
    this.#optedIn = false;
    this.#applyOptState();
  }

  #applyOptState(): void {
    const api = this.#api();
    if (!api) return;
    if (this.#optedIn) api.enable?.();
    else api.disable?.();
  }
}
